import React, { useRef } from 'react';
import { observer } from 'mobx-react';

import { UiButton, UiIcon, UiModal, UiModalContent, UiSwitch } from 'shared/uikit-new';
import { useMedia, useObservable, useOnClickOutside } from 'shared/hooks';
import { COLORS } from 'shared/constants';

import { Store } from 'pages/calendar/store';

import './styles.scss';

export const CalendarPageFilter = observer(function CalendarPageFilter() {
    const ref = useRef<HTMLDivElement>(null);
    const store = useObservable({
        isOpened: false,
    });

    const { isDesktop, is320, is1024, is768 } = useMedia();

    useOnClickOutside(ref, () => {
        if (is320 || is1024 || is768) {
            return;
        }
        store.set('isOpened', false);
    });

    const content = () => (
        <div className={'calendar-page-filter__items'}>
            <UiSwitch value={Store.filter.noWeekends} name={'noWeekends'} onChange={Store.filter.handleChange} className={'calendar-page-filter__switch'}>
                Скрыть выходные
            </UiSwitch>
            <UiSwitch value={Store.filter.onlyOrganizer} name={'onlyOrganizer'} onChange={Store.filter.handleChange} className={'calendar-page-filter__switch'}>
                Только мои задачи и события
            </UiSwitch>
            <hr />
            <UiSwitch value={Store.filter.meeting} name={'meeting'} onChange={Store.filter.handleChange} className={'calendar-page-filter__switch'}>
                События
            </UiSwitch>
            <UiSwitch value={Store.filter.task} name={'task'} onChange={Store.filter.handleChange} className={'calendar-page-filter__switch'}>
                Задачи
            </UiSwitch>
            <UiSwitch value={Store.filter.education} name={'education'} onChange={Store.filter.handleChange} className={'calendar-page-filter__switch'}>
                Обучение
            </UiSwitch>
            <UiSwitch value={Store.filter.reminder} name={'reminder'} onChange={Store.filter.handleChange} className={'calendar-page-filter__switch'}>
                Напоминания
            </UiSwitch>
        </div>
    );

    return (
        <div ref={ref} className={'calendar-page-filter'}>
            <UiButton
                template={'icon'}
                onClick={() => store.set('isOpened', !store.isOpened)}
                style={{
                    backgroundColor: [COLORS._F3F5F8, COLORS._C6CAD1],
                    color: [COLORS._2C2F35, COLORS._2C2F35],
                }}
            >
                <UiIcon.Filter size={16} />
            </UiButton>
            {isDesktop && store.isOpened && <div className='calendar-page-filter__outer'>{content()}</div>}
            {!isDesktop && store.isOpened && (
                <UiModal isOpened={store.isOpened} onClose={() => store.set('isOpened', false)}>
                    <UiModalContent>{content()}</UiModalContent>
                </UiModal>
            )}
        </div>
    );
});
